import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';

import AddUser from '../../components/admin/user/UserDetails/AddUser';

class AddUserContainer extends Component {
  static propTypes = {
    adminAccounts: PropTypes.instanceOf(Object),
  }

  static defaultProps = {
    adminAccounts: {},
  };

  state = {

  }

  render() {
    const { adminAccounts } = this.props;
    return (
      <div className="admin-body usersearch-body">
        {adminAccounts.data && <AddUser />}
      </div>
    );
  }
}


const mapStateToProps = ({ admin }) => ({
  adminAccounts: admin.adminAccounts,
});

// const mapDispatchToProps = dispatch => {
//   return {
//     getAdminAccountList: bindActionCreators(getAdminAccountList, dispatch),
//   };
// };

export default connect(mapStateToProps)(AddUserContainer);

